module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Stetten-8c9c819ad55d3804fb3fff346c453304.png";